import {ErrorDetails} from './types'

/**
 * Generates a JSON string containing error details.
 *
 * @param {string} [code] - Optional error code.
 * @param {string} [message] - Optional error message. If not provided, defaults to `UnexpectedError.ERROR`.
 * @returns {string} A JSON string with `code` and `message` properties.
 */
const getErrorDetails = (code?: string, message?: string): ErrorDetails => {
    return {
        code,
        message: message ? message : ConflictError.ERROR
    }
}

/**
 * Custom Error class representing an unexpected error.
 */
export class ConflictError extends Error {
    /** Static error code to identify the error type. */
    static ERROR = 'ConflictError'
    /** Error code associated with this error instance. */
    code?: string
    errorDetails?: ErrorDetails

    /**
     * Creates a new ConflictError.
     *
     * @param {string} [code] - Optional error code.
     * @param {string} [message] - Optional error message. If not provided, a default error message is generated by `getErrorJSONString`.
     */
    constructor(code?: string, message?: string) {
        super(JSON.stringify(getErrorDetails(code, message)))
        // https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain

        this.name = ConflictError.ERROR
        this.stack = new Error().stack
        this.code = code
        this.errorDetails = getErrorDetails(code, message)
    }
}
